import type { ReactNode } from "react";
import styles from "./Badge.module.css";

export type BadgeVariant = "neutral" | "success" | "danger" | "warning" | "primary";

type BadgeProps = {
  variant?: BadgeVariant;
  className?: string;
  children: ReactNode;
};

/**
 * Inline badge dla komorek tabel (typ dokumentu, status akceptacji, publikacja itp.).
 * Neutralny wyglad domyslnie; warianty (`success`, `danger`, `warning`, `primary`)
 * przemalowuja kolor tekstu i obramowania na tokeny brand. Zolte tlo (`--color-bg-subtle`)
 * i base border sa zawsze te same - wariant to tylko akcent na obwodzie.
 */
export function Badge({ variant = "neutral", className, children }: BadgeProps) {
  const variantClass = variant === "neutral" ? "" : styles[variant];
  return (
    <span className={[styles.root, variantClass, className].filter(Boolean).join(" ")}>
      {children}
    </span>
  );
}
